var MSOListStyleNameEnum;
(function (MSOListStyleNameEnum) {
    MSOListStyleNameEnum["format"] = "mso-level-number-format";
    // 'text' = 'mso-level-text',
    MSOListStyleNameEnum["font"] = "font-family";
    // 'image' = 'list-style-image',
})(MSOListStyleNameEnum || (MSOListStyleNameEnum = {}));
const defaultMsoListStyle = {};
const MsoClassTag = 'MsoListParagraph';
const isSameList = (info, lastInfo) => {
    if (info.tag === lastInfo.tag) {
        return true;
    }
    if (info.level === lastInfo.level + 1 || info.level === lastInfo.level - 1) {
        return true;
    }
    return false;
};
const findMsoListStyle = (styleText, info) => {
    const re = new RegExp(`@list l${info.tag}:level${info.level}[\\S\\s]+?\\{([\\S\\s]+?)\\}`);
    const matches = styleText.match(re);
    if (!matches) {
        return defaultMsoListStyle;
    }
    try {
        const rulesText = matches[1];
        const kvList = rulesText
            .split(';')
            .map((ruleText) => ruleText.split(':').map((kvText) => kvText.trim()));
        const style = {};
        kvList.forEach(([k, v]) => {
            style[k] = v;
        });
        return style;
    }
    catch (ex) {
        return defaultMsoListStyle;
    }
};
const mapWingdingsFontToListStyleType = (char) => {
    switch (char) {
        case 'l':
            return 'disc'; // 1
        case 'n':
            return 'square'; // 2
        case 'u':
            return 'circle'; // 3
        default:
            return 'disc';
    }
};
const mapMsoLevelFormatToListStyleType = (format) => {
    switch (format) {
        case 'alpha-upper':
            return '';
        case 'alpha-lower':
            return '';
        case 'roman-upper':
            return 'upper-roman';
        case 'roman-lower':
            return 'lower-roman';
        case 'chinese-counting-thousand':
            return 'cjk-decimal';
        default:
            return 'decimal';
    }
};
const setBulletListType = (list, listStyle, mark) => {
    if (listStyle[MSOListStyleNameEnum.font] === 'Wingdings') {
        list.style.listStyleType = mapWingdingsFontToListStyleType(mark);
    }
};
const setOrderListType = (list, listStyle) => {
    const format = listStyle[MSOListStyleNameEnum.format];
    if (format) {
        list.style.listStyleType = mapMsoLevelFormatToListStyleType(format);
    }
};
const createBlockList = (doc, node, info, styleText) => {
    var _a;
    const markString = node.querySelector('[style="mso-list:Ignore"]');
    const mark = ((_a = markString === null || markString === void 0 ? void 0 : markString.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '';
    const markWrap = markString === null || markString === void 0 ? void 0 : markString.parentElement;
    const listStlye = info
        ? findMsoListStyle(styleText, info)
        : defaultMsoListStyle;
    let list;
    if (listStlye[MSOListStyleNameEnum.format] === 'bullet' ||
        listStlye[MSOListStyleNameEnum.format] === 'image' ||
        (markWrap === null || markWrap === void 0 ? void 0 : markWrap.style.fontFamily) === 'Wingdings' // fallback
    ) {
        list = doc.createElement('ul');
        setBulletListType(list, listStlye, mark);
    }
    else {
        list = doc.createElement('ol');
        setOrderListType(list, listStlye);
        const numberPieces = mark.match(/\d+/g);
        if (numberPieces) {
            list.start = +numberPieces[numberPieces.length - 1];
        }
    }
    if (info) {
        list.dataset.msoL = info.tag;
        list.dataset.msoLevel = info.level.toString();
    }
    return list;
};
const sanitizeListItem = (doc, node) => {
    const li = doc.createElement('li');
    const paragraph = doc.createElement('p');
    const paragraphStyle = node.getAttribute('style');
    if (paragraphStyle) {
        paragraph.setAttribute('style', paragraphStyle);
        // 重置默认的缩进
        paragraph.style.removeProperty('text-indent');
        paragraph.style.removeProperty('margin-left');
    }
    let msoTag = false;
    Array.from(node.childNodes).forEach((child) => {
        if (child.nodeName === '#comment') {
            const comment = child;
            if (comment.data.startsWith('[if ')) {
                msoTag = true;
            }
            else if (comment.data === '[endif]') {
                msoTag = false;
            }
            return;
        }
        if (msoTag) {
            return;
        }
        paragraph.append(child);
    });
    li.append(paragraph);
    return li;
};
const getListInfo = (node) => {
    const style = node.getAttribute('style');
    const info = style === null || style === void 0 ? void 0 : style.match(/mso-list:\s*l(\d+) level(\d+) lfo(\d+)/);
    if (!info) {
        return null;
    }
    const tag = info[1];
    const level = +info[2];
    const num = +info[3];
    return { tag, level, num };
};
const processMsoListParagraph = (doc, root) => {
    var _a;
    const style = ((_a = doc.head.getElementsByTagName('style')[0]) === null || _a === void 0 ? void 0 : _a.textContent) || '';
    const listNodeList = Array.from(root.querySelectorAll(`.${MsoClassTag}`));
    const listStartNode = listNodeList.shift();
    if (!listStartNode) {
        return;
    }
    const cleanAndNextNode = (node) => {
        const next = listNodeList.shift();
        node.remove();
        return next;
    };
    let lastInfo = getListInfo(listStartNode);
    let node = listStartNode;
    let blockList = createBlockList(doc, listStartNode, lastInfo, style);
    let blockListItem;
    const stack = [];
    node.before(blockList);
    while (node) {
        if (node.className !== MsoClassTag) {
            break;
        }
        const info = getListInfo(node);
        if (!info) {
            // 普通换行
            const paragraph = sanitizeListItem(doc, node).firstChild;
            if (!blockListItem) {
                node.before(paragraph);
            }
            else {
                blockListItem.append(paragraph);
            }
            node = cleanAndNextNode(node);
            continue;
        }
        let lastLevel = lastInfo.level;
        if (!isSameList(info, lastInfo)) {
            break;
        }
        if (info.level > lastLevel) {
            const lastBlockList = blockList;
            stack.push({ blockList, level: lastLevel });
            blockList = createBlockList(doc, node, info, style);
            lastBlockList.append(blockList);
        }
        else if (info.level < lastLevel) {
            if (stack.length) {
                while (lastLevel && lastLevel !== info.level) {
                    const last = stack.pop();
                    lastLevel = last.level;
                    blockList = last.blockList;
                }
            }
            else {
                // 遇到不完整的层级，增加列表层级，替换原有列表
                const lastBlockList = blockList;
                blockList = createBlockList(doc, node, info, style);
                lastBlockList.after(blockList);
                blockList.append(lastBlockList);
                stack.push({ blockList, level: lastLevel });
            }
        }
        blockListItem = sanitizeListItem(doc, node);
        blockList.append(blockListItem);
        lastInfo = info;
        node = cleanAndNextNode(node);
    }
    processMsoListParagraph(doc, root);
};
const processSingleNestedList = (root) => {
    const list = Array.from(root.querySelectorAll('li > ol:first-child, li > ul:first-child'));
    list.forEach((listEl) => {
        const listItemEl = listEl.parentElement;
        if (listItemEl.childElementCount !== 1) {
            return;
        }
        listItemEl.after(listEl);
        listItemEl.remove();
    });
};
export function preprocessHTML(originHTML, opt = {}) {
    let outputHTML = originHTML;
    const parser = new DOMParser();
    const doc = parser.parseFromString(outputHTML, 'text/html');
    // 处理 word 文档中 list 标记
    if (!opt.disableMSOListResolve && outputHTML.includes(MsoClassTag)) {
        processMsoListParagraph(doc, doc.body);
        outputHTML = doc.documentElement.innerHTML;
    }
    // 处理特殊的嵌套 <li><ul><li> ---> <ul><li>
    if (originHTML.match(/<li[^>]*?><(ul|ol)/)) {
        processSingleNestedList(doc.body);
        outputHTML = doc.documentElement.innerHTML;
    }
    return outputHTML;
}
export function createHTMLPreprocessor(opt) {
    return (html) => preprocessHTML(html, opt);
}
//# sourceMappingURL=transforms.js.map